import React from "react";
import "./styles.scss";

const TitleSection = ({ title, Icon = () => <></>, description = "" }) => {
  return (
    <div className="title-section">
      <Icon />
      <h2 className="title-section__title">{title}</h2>
      {description && description.length > 0 && (
        <span className="title-section__description">{description}</span>
      )}
    </div>
  );
};
export default TitleSection;
